import {Component, OnInit,} from '@angular/core';
import {FormBuilder, FormGroup,} from '@angular/forms';
import {HttpClient,} from '@angular/common/http';
import {LoginUserVO,} from '@models/system-vo/login-user-vo';
import {MessageLevel,} from '@models/system-vo/message-level';
import {FileUtil,
        Logger,
        LoginInfoService,
        MessageProvider,
        MessageStackService,
        ScreenMessageHandler,
        SmsMenuPage,
        SmsErrorPage,
        StringUtil,
        SystemConstant,
        ValidationService,
        WindowService,} from '@services/index';
import {SMS005KozaInfoOutVO,} from '@pages/sms005-koza-info/sms005-koza-info-out-vo';
import {SMS005KozaInfoDispVO,} from '@pages/sms005-koza-info/sms005-koza-info-disp-vo';
import * as Const_SMS005 from '@pages/sms005-koza-info/sms005-koza-info-const';
import {SMS008KingakuInfoInVO,} from '@pages/sms008-kingaku-info/sms008-kingaku-info-in-vo';
import {Title,} from '@angular/platform-browser';

@Component({
  selector: 'app-sms005-koza-info',
  templateUrl: './sms005-koza-info.html',
  styleUrls: ['./sms005-koza-info.scss',],
})
/*****************************************************/
/* 処　理：SMS005 家賃残高・振込口座確認 画面
/*
/* 概　要：家賃残高・口座の確認 処理
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/
export class SMS005KozaInfo implements OnInit {
  smsForm!: FormGroup;                  // 画面フォーム
  loginUserVO!: LoginUserVO;            // セッション情報
  sms005ApiRetVO!: SMS005KozaInfoOutVO; // API返却情報
  dispId!: string;                      // ログ表示用ID
  lngType!: string;                     //  言語区分

  // コンテンツエリア：style.width 設定用
  windowsWidth = this.constant.DEFAULT_DEVICE_SCREEN_WIDTH + 'px';

  // ボタン操作可否
  isEnableBtnDetail = false;

  // 画面項目（ラベル入れ替え用）
  public lblName!: string;
  public lblShutokuDate!: string;
  public lblGokei!: string;
  public lblGokeiGaku!: string;
  public lblBankName!: string;
  public lblTenpoName!: string;
  public lblKozaShbt!: string;
  public lblKozaNo!: string;
  public lblMessage01!: string;
  public lblMessage02!: string
  public lblMessage03!: string;
  public lblMessage04!: string;
  public lblBtnDetail!: string;
  public lblBtnMenu!: string;
  public lblScreenName!: string;

  // 明細表示用クラス
  initVo: SMS005KozaInfoDispVO[] = [];

  /**
   * デフォルトコンストラクタ
   */
  constructor(
    private constant: SystemConstant,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private logger: Logger,
    private messageProvider: MessageProvider,
    private windowService: WindowService,
    private titleService: Title,
    private screenMessage: ScreenMessageHandler,
    private smsMenuPage: SmsMenuPage,
    private smsErrPage: SmsErrorPage,
    public fileUtil: FileUtil,
    public loginInfoService: LoginInfoService,
    public stringUtil: StringUtil,
    public validationService: ValidationService
  ) {
    const connVo: LoginUserVO = this.loginInfoService.getLoginUserInfo();
    if (connVo && connVo.hashId != null && !this.stringUtil.isEmpty(connVo.hashId)
        && connVo.accessToken  != null && !this.stringUtil.isEmpty(connVo.accessToken)
        && connVo.refreshToken != null && !this.stringUtil.isEmpty(connVo.refreshToken)) {

      // ログイン情報を取得
      this.loginUserVO = connVo;

      // ログ表示用ID・言語区分セット
      this.dispId = this.loginUserVO.keiyakuInfoId.toString();
      this.lngType = this.loginUserVO.languageType;

    } else {

      // エラーログ出力
      this.logger.error('SMS00501M005E');

      // ログイン情報が取得出来ない場合、エラー画面へ遷移（予期せぬエラー）
      const messageStack = new MessageStackService(MessageLevel.ERROR);
      messageStack.add({messageId: 'SMS99901M013E',});
      this.smsErrPage.transition(messageStack, '', '', constant.DEFAULT_LANGUAGE_TYPE);
      return;
    }
  }

  /**
   * 初期処理(ngOnInit).
   */
  ngOnInit(): void {

    // 画面オブジェクト
    this.smsForm = this.fb.group({
      rdoYatinYmKbn: ['',],
    });

    // 初期表示
    this.formInit();
  }

  /* **************************************************************
   * 初期表示
   * **************************************************************/
  formInit(): void {
    try {
      // ログ出力
      this.logger.info('SMS00501M001I', this.dispId, Const_SMS005.INIT_NAME);

      // 初期表示API処理
      this.getInitData(Const_SMS005.API_INIT_PATH, Const_SMS005.INIT_NAME);

      // デバイスの横幅がデフォルト値未満の場合、横幅を調整する
      if (this.constant.DEFAULT_DEVICE_SCREEN_WIDTH > window.innerWidth) {
        this.logger.debug('■ content-area style.width:' + window.innerWidth);
        this.windowsWidth = window.innerWidth + 'px';
      }

      // ログ出力
      this.logger.info('SMS00501M002I', this.dispId, Const_SMS005.INIT_NAME);

    } catch (ex) {
      this.logger.error('SMS00501M001E', this.dispId, Const_SMS005.INIT_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 初期表示API処理
   * @param {string} path パスAPI
   * @param {string} btnName ボタン名
   */
  private getInitData(path: string, btnName: string): void {

    this.logger.debug(this.dispId + ' ■ 05 start-- getInitData');

    // APIパラメータ設定
    const apiVo = {
      keiyakuInfoId: this.loginUserVO.keiyakuInfoId,
      shouninNo: this.loginUserVO.shouninNo,
    }

    // ログ出力（API入力情報）
    this.logger.debug(this.dispId + ' ■ 05 URL：[' + path + ']');
    this.logger.debug(this.dispId + ' ■ 05 ApiIn   keiyakuInfoId：' + apiVo.keiyakuInfoId);
    this.logger.debug(this.dispId + ' ■ 05 ApiIn   shouninNo    ：' + apiVo.shouninNo);

    // 初期表示API
    this.logger.info('SMS00501M003I', this.dispId, btnName);
    this.httpClient.post<SMS005KozaInfoOutVO>(path, apiVo).subscribe({
      next: (resp) => {
        this.logger.info('SMS00501M004I', this.dispId, btnName);
        if (resp != null) {
          // 初期表示API 返却情報設定
          this.getInitApiReturnInfo(resp);

        } else {
          // エラー画面へ遷移（予期せぬエラー）
          this.logger.error('SMS00501M003E', this.dispId);
          const messageStack = new MessageStackService(MessageLevel.ERROR);
          messageStack.add({messageId: 'SMS99901M013E',});
          this.transitErrPage(messageStack);
        }
        return;
      },
      error: (err: MessageStackService | Error) => {
        // エラーログ
        this.logger.error('SMS00501M004E', this.dispId);

        // Errorの場合
        if (err instanceof Error) {
          // 共通例外処理
          this.commonException(err);
          return;
        }
        // MessageStackの場合
        if (err instanceof MessageStackService && err.messages.length > 0) {
          const messageStack: MessageStackService = new MessageStackService(MessageLevel.ERROR);
          for (const messageError of err.messages) {
            this.logger.debug(this.dispId + ' ■ 05 messageId ：' + messageError.messageId);
            this.logger.error(messageError.messageId);
            messageStack.add({messageId: messageError.messageId,});
          }
          // エラー画面へ遷移
          this.transitErrPage(messageStack);
          return;
        }
      },
    });
  }

  /**
   * 初期表示API 返却情報設定
   *
   * @param {SMS005KozaInfoOutVO} resp API返却情報
   * @returns -
   */
  getInitApiReturnInfo(resp: SMS005KozaInfoOutVO): void {

    this.logger.debug(this.dispId + ' ■ 05 start-- getInitApiReturnInfo');

    // 支払明細
    const retVOList = resp['siharaiVO'];

    // 画面文言（言語区分により変換）
    // {1}　{2} 様
    this.lblName = (this.messageProvider.getMessageString({messageId: 'SMS005' + this.lngType + 'M001F',},  false) || '').replace('{1}', resp['sei']).replace('{2}', resp['mei']);
    // オリコフォレントインシュアでございます。
    this.lblMessage01 = this.messageProvider.getMessageString({messageId: 'SMS005' + this.lngType + 'M002F',},  false) || '';
    // 【現在のお家賃残高】
    this.lblMessage02 = this.messageProvider.getMessageString({messageId: 'SMS005' + this.lngType + 'M003F',},  false) || '';

    // {0}年{1}月
    const ym = (this.messageProvider.getMessageString({messageId: 'SMS005' + this.lngType + 'M004F',},  false) || '');
    // {1} 円
    const yen = (this.messageProvider.getMessageString({messageId: 'SMS005' + this.lngType + 'M006F',},  false) || '');

    // 明細情報 設定
    for (const retVO of retVOList) {

      // ログ出力（API出力情報）
      this.logger.debug(this.dispId + ' ■ 05 ApiOut  yatinYm    ：' + retVO.yatinYm);
      this.logger.debug(this.dispId + ' ■ 05 ApiOut  seikyuGaku ：' + retVO.seikyuGaku);

      const yy = retVO.yatinYm.substring(0, 4);
      const mm = retVO.yatinYm.substring(4, 6);
      this.initVo.push({id: retVO.yatinYm
                      , yatinYm: ym.replace('{1}', yy).replace('{2}', mm)
                      , seikyuGaku: yen.replace('{1}', retVO.seikyuGaku),});
    }


    // ログ出力（API出力情報）
    this.logger.debug(this.dispId + ' ■ 05 ApiOut  goukeiGaku ：' + resp['goukeiGaku']);
    this.logger.debug(this.dispId + ' ■ 05 ApiOut  shutokuDate：' + resp['shutokuDate']);
    this.logger.debug(this.dispId + ' ■ 05 ApiOut  bankName   ：' + resp['bankName']);
    this.logger.debug(this.dispId + ' ■ 05 ApiOut  tenpoName  ：' + resp['tenpoName']);
    this.logger.debug(this.dispId + ' ■ 05 ApiOut  kozaShbt   ：' + resp['kozaShbt']);
    this.logger.debug(this.dispId + ' ■ 05 ApiOut  kozaNo     ：' + resp['kozaNo']);


    // 合計額
    this.lblGokei = (this.messageProvider.getMessageString({messageId: 'SMS005' + this.lngType + 'M005F',},  false) || '');
    this.lblGokeiGaku = yen.replace('{1}', resp['goukeiGaku']);
    // になります。
    this.lblMessage03 = this.messageProvider.getMessageString({messageId: 'SMS005' + this.lngType + 'M007F',},  false) || '';

    // 取得日付
    const sYy = resp['shutokuDate'].substring(0, 4);
    const sMm = resp['shutokuDate'].substring(4, 6);
    const sDd = resp['shutokuDate'].substring(6, 8);

    // （{1}年{2}月{3}日時点）
    this.lblShutokuDate = (this.messageProvider.getMessageString({messageId: 'SMS005' + this.lngType + 'M008F',},  false) || '').replace('{1}', sYy).replace('{2}', sMm).replace('{3}', sDd);
    // 【振込先口座】
    this.lblMessage04 = this.messageProvider.getMessageString({messageId: 'SMS005' + this.lngType + 'M009F',},  false) || '';
    // 詳細金額表示へ
    this.lblBtnDetail = this.messageProvider.getMessageString({messageId: 'SMS005' + this.lngType + 'M010F',},  false) || '';
    // メニューへ戻る
    this.lblBtnMenu = this.messageProvider.getMessageString({messageId: 'SMS005' + this.lngType + 'M011F',},  false) || '';

    // 銀行名称
    this.lblBankName = resp['bankName'];
    // 店舗名称
    this.lblTenpoName = resp['tenpoName'];
    // 当座種別
    if (SystemConstant.C_NYUKIN_RS_KOZA_SHBT_FUTSU === resp['kozaShbt']) {
      this.lblKozaShbt = SystemConstant.C_NYUKIN_RS_KOZA_SHBT_FUTSU_NAME;
    } else {
      this.lblKozaShbt = SystemConstant.C_NYUKIN_RS_KOZA_SHBT_TOZA_NAME;
    }
    // 口座番号
    this.lblKozaNo = resp['kozaNo'];

    // 家賃年月のデフォルト値設定
    //（この画面については、家賃年月が0件のケースがあるので、データある時のみ設定）
    if (this.initVo.length !== 0) {
      this.smsForm.get('rdoYatinYmKbn')?.setValue(this.initVo[0].id);
      this.logger.debug(this.dispId + ' ■ 05 default rdoYatinYmKbn ：' + this.smsForm.get('rdoYatinYmKbn')?.value);
      this.isEnableBtnDetail = true;
    }

    // ブラウザ・ヘッダータイトル
    const screenName = this.messageProvider.getMessageString({messageId: 'SMS005' + this.lngType + 'M001T',}) || '';
    const companyName = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M001T',}) || '';
    this.titleService.setTitle(screenName + ' | ' + companyName);
    document.getElementById('lblScreenTitle')!.innerText = screenName;

    this.logger.debug(this.dispId + ' ■ 05 end---- getInitApiReturnInfo');
    return;
  }

  /* **************************************************************
   * 詳細金額表示へボタン
   * **************************************************************/
  detailClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00501M005I', this.dispId, Const_SMS005.BTN_DETAIL_NAME);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // 画面入力チェック
      if (!this.inputCheck()) {
        return;
      }

      // 画面遷移
      this.nextPage(this.smsForm.get('rdoYatinYmKbn')?.value);

    } catch (ex) {
      this.logger.error('SMS00501M002E', this.dispId, Const_SMS005.BTN_DETAIL_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 画面入力チェック
   * @returns true/false
   */
  inputCheck(): boolean {
    let isRet = true;
    const messageStack = new MessageStackService(MessageLevel.ERROR);

    this.logger.debug(this.dispId + ' ■ 05 入力チェック開始');

    // ------------------------------------------
    // 必須チェック
    // ------------------------------------------
    // 家賃年月
    if (this.smsForm.get('rdoYatinYmKbn')?.value === '') {
      this.logger.debug('■ 05 家賃年月：必須NG');
      isRet = false;
    }

    // ------------------------------------------
    // 入力チェック結果判定
    // ------------------------------------------
    if (isRet) {
      // 入力チェックOK
      this.logger.info('SMS99901M004I', this.dispId);
    } else {
      // 入力チェックNG
      this.logger.info('SMS99901M005I', this.dispId);
      messageStack.add({messageId: 'SMS999' + this.lngType + 'M011E',});
      this.screenMessage.showMessage(messageStack);
    }

    this.logger.debug(this.dispId + ' ■ 05 入力チェック終了');

    return isRet;
  }

  /**
   * 画面遷移処理
   * @param {string} yatinYmKbn
   */
  nextPage(yatinYmKbn: string): void{

    this.logger.debug(this.dispId + ' ■ 05 → 08 画面遷移');

    // POSTパラメータ設定
    const info008Vo: SMS008KingakuInfoInVO = new SMS008KingakuInfoInVO();
    info008Vo.yatinYm = yatinYmKbn;
    this.windowService.transit<SMS008KingakuInfoInVO>('SMS008', info008Vo);
  }

 /* **************************************************************
   * メニューへ戻るボタン押下
   * **************************************************************/
  backClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00501M005I', this.dispId, Const_SMS005.BTN_BACKMENU_NAME);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // SMS001：メインメニュー画面に遷移
      this.smsMenuPage.transition(this.loginUserVO.hashId,
                                  this.loginUserVO.menuNo,
                                  this.loginUserVO.languageType);

    } catch (ex) {
      this.logger.error('SMS00501M002E', this.dispId, Const_SMS005.BTN_BACKMENU_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 共通例外処理
   * @param {Error} err
   */
  private commonException(err?: Error | unknown): void {

    this.logger.debug(this.dispId + ' ■ 05 共通例外処理開始');

    // エラーログ
    if (err instanceof Error) {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err.message, this.dispId);
    } else {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err, this.dispId);
    }

    // エラー画面へ遷移（予期せぬエラー）
    const messageStack = new MessageStackService(MessageLevel.ERROR);
    messageStack.add({messageId: 'SMS99901M013E',});
    this.transitErrPage(messageStack);
  }

  /**
   * エラー画面へ遷移
   * @param {MessageStackService} messageStack
   */
  transitErrPage(messageStack: MessageStackService): void {

    // SMS011：エラー画面に遷移
    this.smsErrPage.transition(messageStack,
                               this.loginUserVO.hashId,
                               this.loginUserVO.menuNo,
                               this.loginUserVO.languageType);
  }

}
